export const orgAgreementTranslations = {
  lv: {
    title: 'Līgumi',
    description: 'Katram praktikantam savs līgums. Bezmaksas kontā parakstāt pats.',
    count_zero: '{{count}} līgumu',
    count_one: '{{count}} līgums',
    count_other: '{{count}} līgumi',
    search: 'Meklēt līgumu…',
    empty: 'Līgumi nav atrasti',
    columns: {
      intern: 'Praktikants',
      nr: 'Nr.',
      eduOrgName: 'Izglītības iestāde',
      internship: 'Prakse',
      supervisorStart: 'Sākums',
      supervisorEnd: 'Beigas',
      Edu: 'Iestādes paraksts',
      Intern: 'Praktikanta paraksts',
      Org: 'Mūsu paraksts',
      status: 'Statuss',
    },
    statuses: {
      toSignEdu: 'Gaida iestādes parakstu',
      toSignIntern: 'Gaida praktikanta parakstu',
      toSignOrg: 'Gaida mūsu parakstu',
      signed: 'Parakstīts',
    },
    signedBy: 'Parakstīts — {{signatory}}, {{date}}',
    notSigned: 'Nav parakstīts',
    actions: {
      menu: 'Līguma darbības',
      signAtEparaksts: 'Parakstīt ar e-parakstu',
      sendToSign: 'Pārsūtīt parakstīšanai',
      uploadSigned: 'Augšupielādēt parakstītu līgumu',
      download: 'Lejupielādēt līgumu',
    },
    upload: {
      hint: 'Augšupielādējiet līgumu ar uzņēmuma parakstu (.edoc vai .asice). Failā jābūt visiem līdz šim pievienotajiem parakstiem.',
      file: 'Parakstītais līgums',
      fileRequired: 'Izvēlieties parakstīto līguma failu',
      submit: 'Augšupielādēt',
    },
    send: {
      hint: 'Saite līguma parakstīšanai uzņēmuma vārdā tiks nosūtīta uz norādīto e-pastu. Saņēmējs to atvērs, ievadot šo pašu e-pastu.',
      email: 'E-pasts',
      emailInvalid: 'Ievadiet derīgu e-pasta adresi',
      submit: 'Nosūtīt',
    },
    messages: {
      downloadError: 'Neizdevās lejupielādēt līgumu.',
      sent: 'Saite parakstīšanai nosūtīta uz {{email}}.',
      uploaded: 'Parakstītais līgums augšupielādēts.',
      failed: 'Darbība neizdevās.',
    },
  },
  en: {
    title: 'Agreements',
    description: 'Each intern has their own agreement. In a free account, you sign it yourself.',
    count_one: '{{count}} agreement',
    count_other: '{{count}} agreements',
    search: 'Search agreements…',
    empty: 'No agreements found',
    columns: {
      intern: 'Intern',
      nr: 'No.',
      eduOrgName: 'Educational institution',
      internship: 'Internship',
      supervisorStart: 'Start',
      supervisorEnd: 'End',
      Edu: 'Institution signature',
      Intern: 'Intern signature',
      Org: 'Our signature',
      status: 'Status',
    },
    statuses: {
      toSignEdu: 'Awaiting the institution’s signature',
      toSignIntern: 'Awaiting the intern’s signature',
      toSignOrg: 'Awaiting our signature',
      signed: 'Signed',
    },
    signedBy: 'Signed — {{signatory}}, {{date}}',
    notSigned: 'Not signed',
    actions: {
      menu: 'Agreement actions',
      signAtEparaksts: 'Sign with e-signature',
      sendToSign: 'Send for signing',
      uploadSigned: 'Upload signed agreement',
      download: 'Download agreement',
    },
    upload: {
      hint: 'Upload the agreement with the company’s signature (.edoc or .asice). The file must carry every signature added so far.',
      file: 'Signed agreement',
      fileRequired: 'Choose the signed agreement file',
      submit: 'Upload',
    },
    send: {
      hint: 'A link to sign the agreement on behalf of the company will be sent to this email. The recipient opens it by typing the same email.',
      email: 'Email',
      emailInvalid: 'Enter a valid email address',
      submit: 'Send',
    },
    messages: {
      downloadError: 'Could not download the agreement.',
      sent: 'Signing link sent to {{email}}.',
      uploaded: 'The signed agreement was uploaded.',
      failed: 'The action failed.',
    },
  },
}
